import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';

import TransactionStateQuery from '../../graphql/TransactionState';
import {
  TransactionStateQuery as TransactionStateQueryResult,
  TransactionStateQueryVariables,
} from '../../graphql/__generated__/TransactionStateQuery';
import { openModal } from '../../redux/modal';
import CancelTransactionMessage, {
  label,
} from '../Modal/messages/CancelTransactionMessage';

const TransactionProgressCheck: FunctionComponent = ({ children }) => {
  const dispatch = useDispatch();
  const { data } = useQuery<
    TransactionStateQueryResult,
    TransactionStateQueryVariables
  >(TransactionStateQuery, { fetchPolicy: 'network-only', ssr: false });

  const hasTransactionStarted =
    data?.user?.cart?.state === 'TRANSACTION_STARTED';

  useEffect(() => {
    if (hasTransactionStarted) {
      dispatch(openModal({ content: <CancelTransactionMessage />, label }));
    }
  }, [hasTransactionStarted, dispatch]);

  return <>{children}</>;
};

export default TransactionProgressCheck;
